import { HostBinding,Component,Renderer2, OnInit ,ViewEncapsulation, AfterViewInit, OnDestroy,ViewChild } from '@angular/core';
import {Observable, pipe, throwError, Subscription} from 'rxjs'; 
// import { Res,IProfile } from 'src/app/entity';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import {NewsletterService} from '../../services/newsletter.service';
import {HomeService} from '../../services/home.service';
import {ArticleService} from '../../services/article.service'
import {MessageService} from '../../message.service';
import {CommonService} from '../../services/common.service';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import {AppSettings} from '../../settings';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-newsletter-view',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './newsletter-view.component.html',
  styleUrls: ['./newsletter-view.component.css']
})

export class NewsletterViewComponent extends BaseComponent implements OnInit ,OnDestroy,IRule {

  @HostBinding('style.width') public width: string = '100%'; 

  msg:any;
  userName='';
  navigationsType=[];

  newsletterid:number=0;
  sections:Array<any>=[];
  sectionData:Array<any>=[];
  bannerImage:any ;
  url:any=AppSettings.API_ENDPOINT;
  permissions:any=[];
  commonService:any;

  notification:any=[];

  newsletterStatus:string='';

  record:any=[];

  router:any;
  toastr:any;

  redirected_from:string='';
  headerDescription:any

  source:any;

  searchTxt:any;
  prevsource:any;

  latest_newsletters:any = [];
  
  loader_image:boolean =true

  constructor(private _com:CommonService , private route: ActivatedRoute,homeservice:HomeService,_router: Router,private newsService:NewsletterService , toastr: ToastrService,msg:MessageService,private articleService:ArticleService,private renderer: Renderer2){
   
    super(msg,toastr,homeservice,_router);
    this.msg =msg;
    this.commonService =_com;        
    
    this.router = _router;
    this.toastr=toastr;

    // this.newsletterid = +this.route.snapshot.paramMap.get('id');

    this.route.queryParams.subscribe(params =>{

      if(params.search!=undefined){

        this.searchTxt = params.search;

      }
      if(params.source!=undefined){
        this.source = params.source;

      }
    })

    if(this.source=='search'){
      this.prevsource = 'search'
    }else{
     this.prevsource = 'newsletter'
    }

    this.route.params.subscribe(
      params => {
        this.newsletterid = params['id'];
        this.redirected_from = 'newsletter-'+this.newsletterid
        this.getNewsletter(this.newsletterid)
        
      }
   );

   try{


    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

    if(!tokenA) throw 'Error in parse';
    
    if(!JSON.parse(tokenA)) throw 'Error in json parse';
  
    tokenA = JSON.parse(tokenA);


    let data2={
        token:tokenA.token,
        reqData:{'page':'similar',similar:this.newsletterid,'limit':10}
    }

    this.newsService.newsletterData(data2).subscribe( (response)=>{


      if(response.status=='success'){

        this.latest_newsletters =  response.newsletter;

        setTimeout(() => {
          $('#related-newsletter').owlCarousel({
            loop:true,
            margin:15,
            items:4,
          autoplay:false,
            nav:true,
          dots:false,
           responsiveClass: true,
            responsive: {
                0:{
                  items: 1
                },
                480:{
                  items: 1
                },
                769:{
                  items: 2
                },
            1024:{
                  items: 4
                }
            }
          })
        }, 100);

        

       
      } 
    });

    let data3={
      newsletter:this.newsletterid,
      event:'nvstart',
      source:'web',
      token:tokenA.token
    }
    this.articleService.analytics(data3).subscribe( (res)=>{

      if(res.status=='success' ){

      }
    })

  }catch(Exc ){

    this.router.navigate(['/login']);
  }
   
  }

 
  getNewsletter(id){

    try{


      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
    
      tokenA = JSON.parse(tokenA);


        if(this.newsletterid){


          let data={
            token:tokenA.token,
            id:id,
            source:this.source
          }


          this.newsService.newsletterDataById(data).subscribe( (elem)=>{

         
      
            if(elem.newsletter){

              this.loader_image =false

              this.permissions =elem.permission;

              this.msg.sendMessage({'type':'open_layout_user','user':elem.user});

              this.userName=elem.user.name;

              this.navigationsType=elem.navigation;

              this.notification =elem.notification;

              this.record =elem.newsletter[0];

              this.msg.sendMessage({type:'customeEvent',event:'newsletter',value:this.record.templateName,source:localStorage.previous,newsletterId:this.record.id});


              this.headerDescription = elem.newsletter[0].sections.header


              let p =  this.record.status =='Sent' ||  this.commonService.check_newsletter_mange_exists(this.permissions) ;

              if(!p){

                        
               this.toastr.error(' You dont have the permission to view the newsletter  !', '', {timeOut: 3000});
      
               this.router.navigate(['/newsletter']);

              }


             

              this.newsletterStatus = elem.newsletter[0].status;

              this.broadcast_menu();

              this.bannerImage=elem.newsletter[0].sections.bannerImage;
              this.sections=elem.newsletter[0].sections;
              this.sectionData=elem.newsletter[0].sections.sectionData;

              

              
            }else{
              this.toastr.error('Newsletter Not Found  !', '', {timeOut: 3000});
              this.router.navigate(['/login']);
            }
        
          });
    

        }

      

    }catch(Exc ){

      this.router.navigate(['/login']);
    }
  }

  setMyStyles(val) {

    let style={
      height:'0px'
    }

   if(val.navObject.descriptionCss!=undefined && val.navObject.descriptionCss.fontSize!=undefined){

     style={
      height:val.navObject.descriptionCss.fontSize
    }

   }
   return style
 }

 broadcast_menu(){
    
  this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType,currentPage:'newsletter'});
 }

  ngOnInit() {

    window.scrollTo(0, 0);
    
  }

  back(){ 
    
    if(this.source=='home'){
      this.router.navigate(['/home']);
    }else if(this.source=='newsletter' || this.source==undefined){
      this.router.navigate(['/newsletter']);
    }else if(this.source=='search'){
      this.msg.sendMessage({'type':'search','details':this.searchTxt});
      this.router.navigate(['/search']);
    }
  }

  ngAfterViewInit(){
   
  }

  viewArticle(id:number){

    this.loader_image =true
    window.scrollTo(0, 0);
   
    this.router.navigate(['/newsletter/'+id+'/view'], { queryParams: { 'source':'newsletter'} });
  }

}
